import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJImageExtenderGenerateNumber from '../view/FJImageExtenderGenerateNumber';
import FJActionImageExtender from '../../../../redux/action/FJActionImageExtender';

const FJImageExtenderGenerateNumberContainer = memo(function FJTextToImageGenerateNumberContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const generateNumber = useSelector(state => state.imageExtender.generateNumber);

    const handleChangeGenerateNumber = useCallback(
        value => {
            dispatch(FJActionImageExtender.changeGenerateNumberAction(value));
        },
        [dispatch],
    );

    return <FJImageExtenderGenerateNumber generateNumber={generateNumber} onChange={handleChangeGenerateNumber} />;
});

export default FJImageExtenderGenerateNumberContainer;
